const agb = {
  policyMessage: 'I have read the {link} of EineApotheken GmbH & Co. KGaA and agree to their validity.',
  dataProtectionMessage: 'My user account should be available to me as usual with all information about me and my orders. I have taken note of the {link} of EineApotheken GmbH & Co. KGaA.',
  termsOfUse: 'Terms of Use',
  errorTermsOfUse: 'Please accept our terms of use',
  errorPolicy: 'Please accept our privacy policy',
  privacyPolicy: 'Privacy Policy',
  errorUpdatePolicy: 'Error while updating policies.',
  thankYouMessage: 'Thanks very much!',
  welcomeMessage: 'Welcome!',
  cancel: 'Cancel',
  accept: 'Accept',
  approvalMessage: 'We have adjusted our terms of use and data protection information. In order to be able to provide you with your user account unchanged, we ask you for the following approvals:',
}

export default agb
